import moment from 'moment';
import { beginTask, endTask } from 'redux-nprogress';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectCurrent } from '../../../../store/reducers/season';
import { selectDefaultFormula } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

/* eslint camelcase: 0 */
/* eslint max-len: 0 */

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'teamPositionRankings';
export const selectTeamPositionRankingsState = state => state[STORE_KEY];
// export const selectRanking = state => selectCustomState(state).ranking;

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  rankings: null,
  selectedYear: null,
  selectedStartWeek: null,
  selectedEndWeek: null,
  selectedFormula: 1,
  minWeek: null,
  maxWeek: null,
  hasLoaded: false,
  error: null,
};

const rankingsReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default rankingsReducer;

// ------------------------------------
// Fetch rankings data
// ------------------------------------
export const FETCH_TEAM_POSITION_RANKINGS_REQUEST = `${STORE_KEY}/FETCH_TEAM_POSITION_RANKINGS_REQUEST`;
export const FETCH_TEAM_POSITION_RANKINGS_SUCCESS = `${STORE_KEY}/FETCH_TEAM_POSITION_RANKINGS_SUCCESS`;
export const FETCH_TEAM_POSITION_RANKINGS_ERROR = `${STORE_KEY}/FETCH_TEAM_POSITION_RANKINGS_ERROR`;

export const fetchTeamPositionRankingsRequest = () => ({
  type: FETCH_TEAM_POSITION_RANKINGS_REQUEST,
  payload: { },
});
export const fetchTeamPositionRankingsSuccess = rankings => ({
  type: FETCH_TEAM_POSITION_RANKINGS_SUCCESS,
  payload: { rankings },
});
export const fetchTeamPositionRankingsError = error => ({
  type: FETCH_TEAM_POSITION_RANKINGS_ERROR,
  payload: { error },
});

actions[FETCH_TEAM_POSITION_RANKINGS_REQUEST] = state => ({ ...state,
});
actions[FETCH_TEAM_POSITION_RANKINGS_SUCCESS] = (state, { payload: { rankings } }) => ({ ...state,
  rankings,
});
actions[FETCH_TEAM_POSITION_RANKINGS_ERROR] = (state, { payload: { error } }) => ({ ...state,
  error,
});

export const fetchTeamPositionRankings = (year, startWeek, endWeek, formulaId) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(fetchTeamPositionRankingsRequest());

    const state = getState();
    const { selectedYear, selectedFormula } = selectTeamPositionRankingsState(state);

    const rankings = await api.rankings.getTeamPositionRankings({
      season: year || selectedYear,
      start_week: startWeek,
      end_week: endWeek,
      formula_id: formulaId || selectedFormula,
    });

    dispatch(fetchTeamPositionRankingsSuccess(rankings));
  } catch (error) {
    console.error(error);
    dispatch(fetchTeamPositionRankingsError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// Change current year/season
// ------------------------------------
export const CHANGE_SELECTED_YEAR = `${STORE_KEY}/CHANGE_SELECTED_YEAR`;
export const changeSelectedYear = year => ({
  type: CHANGE_SELECTED_YEAR,
  payload: { year },
});
actions[CHANGE_SELECTED_YEAR] = (state, { payload: { year } }) => ({ ...state,
  selectedYear: year,
});

// ------------------------------------
// Change start week
// ------------------------------------
export const CHANGE_SELECTED_START_WEEK = `${STORE_KEY}/CHANGE_SELECTED_START_WEEK`;
export const changeSelectedStartWeek = startWeek => ({
  type: CHANGE_SELECTED_START_WEEK,
  payload: { startWeek },
});
actions[CHANGE_SELECTED_START_WEEK] = (state, { payload: { startWeek } }) => ({ ...state,
  selectedStartWeek: startWeek,
});

// ------------------------------------
// Change end week
// ------------------------------------
export const CHANGE_SELECTED_END_WEEK = `${STORE_KEY}/CHANGE_SELECTED_END_WEEK`;
export const changeSelectedEndWeek = endWeek => ({
  type: CHANGE_SELECTED_END_WEEK,
  payload: { endWeek },
});
actions[CHANGE_SELECTED_END_WEEK] = (state, { payload: { endWeek } }) => ({ ...state,
  selectedEndWeek: endWeek,
});

// ------------------------------------
// Change current formula
// ------------------------------------
export const CHANGE_SELECTED_FORMULA = `${STORE_KEY}/CHANGE_SELECTED_FORMULA`;
export const changeSelectedFormula = formula => ({
  type: CHANGE_SELECTED_FORMULA,
  payload: { formula },
});
actions[CHANGE_SELECTED_FORMULA] = (state, { payload: { formula } }) => ({ ...state,
  selectedFormula: formula,
});

// ------------------------------------
// Change the table column group data
// ------------------------------------
export const CHANGE_TABLE_COLUMN_GROUPS = `${STORE_KEY}/CHANGE_TABLE_COLUMN_GROUPS`;
export const changeTableColGroups = tableColGroups => ({
  type: CHANGE_TABLE_COLUMN_GROUPS,
  payload: { tableColGroups },
});
actions[CHANGE_TABLE_COLUMN_GROUPS] = (state, { payload: { tableColGroups } }) => ({ ...state,
  tableColGroups,
});

// ------------------------------------
// Loads Team Position Rankings screen
// ------------------------------------
export const LOAD_TEAM_POSITION_RANKINGS_DATA_REQUEST = `${STORE_KEY}/LOAD_TEAM_POSITION_RANKINGS_DATA_REQUEST`;
export const LOAD_TEAM_POSITION_RANKINGS_DATA_SUCCESS = `${STORE_KEY}/LOAD_TEAM_POSITION_RANKINGS_DATA_SUCCESS`;
export const LOAD_TEAM_POSITION_RANKINGS_DATA_ERROR = `${STORE_KEY}/LOAD_TEAM_POSITION_RANKINGS_DATA_ERROR`;

export const loadTeamPositionRankingsViewRequest = () => ({
  type: LOAD_TEAM_POSITION_RANKINGS_DATA_REQUEST,
  payload: { },
});
export const loadTeamPositionRankingsViewSuccess = (season, start_week, end_week, selectedStartWeek, selectedEndWeek, formula_id) => ({
  type: LOAD_TEAM_POSITION_RANKINGS_DATA_SUCCESS,
  payload: { season, start_week, end_week, selectedStartWeek, selectedEndWeek, formula_id },
});
export const loadTeamPositionRankingsViewError = error => ({
  type: LOAD_TEAM_POSITION_RANKINGS_DATA_ERROR,
  payload: { error },
});

actions[LOAD_TEAM_POSITION_RANKINGS_DATA_REQUEST] = state => ({ ...state,
});
actions[LOAD_TEAM_POSITION_RANKINGS_DATA_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  selectedYear: payload.season,
  selectedStartWeek: payload.selectedStartWeek,
  selectedEndWeek: payload.selectedEndWeek,
  selectedFormula: payload.formula_id,
  minWeek: payload.start_week,
  maxWeek: payload.end_week,
});
actions[LOAD_TEAM_POSITION_RANKINGS_DATA_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadTeamPositionRankingsView = () => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadTeamPositionRankingsViewRequest());

    const state = getState();
    let { season, formula_id } = selectQuery(state);
    let { selectedStartWeek, selectedEndWeek } = selectTeamPositionRankingsState(state);
    const { season: currentSeason, week: currentWeek } = selectCurrent(state, 'stats');
    if (!season) season = currentSeason;
    if (!formula_id) formula_id = selectDefaultFormula(state).id;

    // Need to exclude postseason for now
    // const { stats_weeks } = await api.lookups.getSeasonWeeks(season);
    const numWeeks = season >= 2021 ? 18 : 17; // stats_weeks.length;
    const start_week = 1;
    const end_week = season === currentSeason && currentWeek < 17 ? currentWeek : numWeeks;
    if (!selectedStartWeek) selectedStartWeek = start_week;
    if (!selectedEndWeek || selectedEndWeek > end_week) selectedEndWeek = end_week;

    await dispatch(fetchTeamPositionRankings(season, selectedStartWeek, selectedEndWeek, formula_id));

    const columns = ['Team', 'QB', 'RB', 'WR', 'TE', 'PK', 'DF'];
    const tableColGroups = {
      offensive: [{ name: 'Team Position Offensive Ranks', columns }],
      defensive: [{ name: 'Team Position Defensive Ranks', columns }],
    };
    dispatch(changeTableColGroups(tableColGroups));

    dispatch(loadTeamPositionRankingsViewSuccess(season, start_week, end_week, selectedStartWeek, selectedEndWeek, formula_id));
  } catch (error) {
    console.error(error);
    dispatch(loadTeamPositionRankingsViewError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const TEAM_POSITION_RANKINGS_VIEW = `${STORE_KEY}/TEAM_POSITION_RANKINGS_VIEW`;
viewNames[TEAM_POSITION_RANKINGS_VIEW] = 'TeamPositionRankings';
routes[TEAM_POSITION_RANKINGS_VIEW] = {
  path: '/stats/team_position_rankings',
  thunk: async (dispatch, getState) => {
    await dispatch(loadTeamPositionRankingsView());
    await dispatch(loadToolDescriptions());
  }
};



// WEBPACK FOOTER //
// ./src/app/views/TeamPositionRankings/module/teamPositionRankings.js